import React from "react"
import { Helmet } from "react-helmet"

export interface TwitterSeoProps {
  site?: string
}

export const Twitter: React.FC<TwitterSeoProps> = ({ site }) => (
  <Helmet>
    {site && <meta name="twitter:site" content={site} />}
    <meta name="twitter:card" content="summary_large_image" />
  </Helmet>
)

export default Twitter
